import React, { useState } from "react";

import { formatTemperature } from '../../util/temperature';
import { useTemperatureUnit } from '../../util/useTemperatureUnit';

export default function WeatherTooltip({ children, temp, weather_condition, wind, irradiance, bom_temperature, position = "top" }) {
  const temperatureUnit = useTemperatureUnit();
  const [visible, setVisible] = useState(false);

  return (
    <div
      className="tooltip-wrapper"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
      tabIndex={0}
    >
      {children}
      {visible && (
        <div className={`tooltip-box tooltip-${position}`}>
          <div className='siteConditions'>
            <strong>SITE CONDITIONS</strong>
            <h2>{temp != null ? formatTemperature(temp, temperatureUnit) : '—'}</h2>
            <span>{weather_condition}</span>
            <span>{wind}</span>
            <span>{irradiance != null ? `${irradiance} W/m²` : '—'}</span>
            <span>{bom_temperature != null ? `${formatTemperature(bom_temperature, temperatureUnit)} BOM` : '— BOM'}</span>
          </div>
        </div>
      )}
    </div>
  );
}
